import Swal from "sweetalert2";

document.addEventListener("DOMContentLoaded", () => {
  const noCall = document.querySelector("#no-call-iil");

  if (noCall) {
    const genevaTime = noCall.dataset.genevatime;
    const userLang = navigator.language;

    let title = "Reception closed";
    let buttonText = "Understood !";
    let message = `It is ${genevaTime} in Geneva, and our office is open from 8am to 6pm, from Monday to Friday. Please renew your call later.`;

    if (userLang === "fr-FR") {
      title = "Réception fermée";
      message = `Il est actuellement ${genevaTime} à Genève, la réception est ouverte du lundi au vendredi, de 8h à 18h. Veuillez renouveler votre appel.`;
      buttonText = "Compris !";
    }

    noCall.addEventListener("click", () => {
      Swal.fire({
        title: title,
        text: message,
        icon: "error",
        confirmButtonText: buttonText,
        buttonsStyling: true,
        customClass: {
          confirmButton: "cta",
        },
      });
    });
  }
});
